const prefix = 'BATCH_UPDATE_'

const SET_VALIDATION_DATA_LOADING = `${prefix}SET_VALIDATION_DATA_LOADING`
const SET_VALIDATION_DATA = `${prefix}SET_VALIDATION_DATA`

export {
  SET_VALIDATION_DATA_LOADING,
  SET_VALIDATION_DATA
}
